
import { MUTATIONS } from '@/store/mutations';
import { GETTERS } from '@/store/getters';
import NavigationFooter from '@/core/components/NavigationFooter.vue';
import BookingTime from '@/core/components/BookingTime.vue';
import BookingTimePreview from '../components/BookingTimePreview.vue';
import { CreateBooking } from '@/models/bookings';
import moment from 'moment';
import { CREATE_BOOKING_DATE_FORMAT } from '@/utils/constants';
import BookingTimeMixin from '../mixins/BookingTimeMixin';
import TimePicker from '../../../core/components/TimePicker.vue';

export default BookingTimeMixin.extend({
  data() {
    return {
      date: '',
      time: '',
      booking: {} as CreateBooking,
    };
  },

  components: {
    NavigationFooter,
    BookingTime,
    BookingTimePreview,
    TimePicker,
  },

  created() {
    this.$store.commit(MUTATIONS.SET_HEADER, { title: this.$t('bookings.headers.start_time'), subtitle: '' });
    this.booking = this.$store.getters[GETTERS.GET_CREATE_BOOKING];
    this.time = this.booking.startTime ?? this.getCurrentTime();
    this.date = moment(this.booking.startDate, CREATE_BOOKING_DATE_FORMAT).format('YYYY-MM-DD');

    this.computeStartTimeAllowedTimes(this.date);

    // Get the first available time based on other bookings.
    const [hour, minute] = this.time.split(':');
    const available_time = this.getFirstAvailableTime(hour, minute);
    if (available_time.hour && available_time.minute) {
      this.time = `${available_time.hour}:${available_time.minute}`;
    }
  },

  computed: {
    minTime(): string {
      if (moment().startOf('day').isSame(moment(this.booking.startDate, CREATE_BOOKING_DATE_FORMAT))) {
        return moment().format('HH:mm:ss.SSS');
      }
      return '';
    },
  },

  methods: {
    onTimeSelected(): void {
      this.booking.startTime = this.time;
      this.$store.commit(MUTATIONS.SET_CREATE_BOOKING, this.booking);
      this.$router.push('/booking/end-date');
    },

    getCurrentTime(): string {
      return moment().format('HH:mm:ss.SSS');
    },
  },
});
